<div class="modal-header">
  <h4 class="modal-title">Mua thêm kim cương 🏵️</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <div class="mb-3">
    <label for="phone" class="form-label">Số điện thoại liên hệ</label>
    <input 
      type="tel" 
      class="form-control" 
      id="phone" 
      [(ngModel)]="phone" 
      placeholder="Nhập số điện thoại"
    >
  </div>
  
  <div class="mb-3">
    <label for="diamondAmount" class="form-label">Số lượng kim cương 🏵️</label>
    <input 
      type="number" 
      class="form-control" 
      id="diamondAmount" 
      [(ngModel)]="diamondAmount" 
      min="1"
    >
  </div>
  
  <div class="alert alert-info">
    <i class="bi bi-info-circle-fill me-2"></i>
    Chúng tôi sẽ liên hệ với bạn qua số điện thoại để xác nhận và hướng dẫn thanh toán.
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Hủy</button>
  <button type="button" class="btn btn-primary" (click)="submit()" [disabled]="!isValid()">
    Gửi yêu cầu
  </button>
</div>